"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var glamor_1 = require("glamor");

var glamor_tachyons_1 = require("glamor-tachyons");

var SurfaceComponent =
/*#__PURE__*/
function (_preact_1$Component) {
  _inherits(SurfaceComponent, _preact_1$Component);

  function SurfaceComponent() {
    _classCallCheck(this, SurfaceComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SurfaceComponent).apply(this, arguments));
  }

  _createClass(SurfaceComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          name = _this$props.name,
          tab = _this$props.tab;
      this.props.registerSurface(name, tab, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          visible = _this$props2.visible,
          styles = _this$props2.styles;
      var finalStyles = Object.assign({}, SurfaceComponent.defaultStyles, styles);
      var width = finalStyles.width,
          height = finalStyles.height;
      var maxHeight = finalStyles.maxHeight,
          maxWidth = finalStyles.maxWidth;
      maxHeight = height === SurfaceComponent.defaultStyles.height ? maxHeight : height;
      maxWidth = width === SurfaceComponent.defaultStyles.width ? maxWidth : width;
      var surfaceStyle = glamor_1.css({
        display: visible ? 'block' : 'none',
        backgroundColor: 'white',
        marginTop: '10px',
        marginBottom: '10px',
        boxShadow: '0 0 6px -3px #777',
        padding: '10px !important',
        height: height,
        width: width,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        overflow: 'auto'
      });
      var labelStyle = glamor_1.css(Object.assign({
        backgroundColor: 'white',
        boxSizing: 'border-box',
        borderBottom: '1px solid #357EDD',
        lineHeight: '2em',
        marginBottom: '20px'
      }, glamor_tachyons_1.tachyons('fw6 tc')));
      var drawAreaStyle = glamor_1.css({
        boxSizing: 'border-box'
      });
      return preact_1.h("div", {
        className: "".concat(surfaceStyle, " tf-surface"),
        ref: function ref(r) {
          return _this.container = r;
        },
        "data-visible": visible
      }, preact_1.h("div", {
        className: "".concat(labelStyle, " tf-label"),
        ref: function ref(r) {
          return _this.label = r;
        }
      }, name), preact_1.h("div", {
        className: "".concat(drawAreaStyle, " tf-draw-area"),
        ref: function ref(r) {
          return _this.drawArea = r;
        }
      }));
    }
  }]);

  return SurfaceComponent;
}(preact_1.Component);

SurfaceComponent.defaultStyles = {
  maxWidth: '580px',
  maxHeight: '580px',
  height: 'auto',
  width: 'auto'
};
exports.SurfaceComponent = SurfaceComponent;